<template>
  <div id="journal">
    <!-- all_in -->
    <div class="break_box">
      <Breadcrumb>
        <breadcrumbs></breadcrumbs>
      </Breadcrumb>
    </div>
    <div class="con_all" v-if="!$route.meta.keepAliveSub">
      <div class="con_box2">
        <table width="100%">
          <tr>
            <td>{{showPage.type}}</td>
          </tr>
          <tr v-for="(typeobj,index) in types" :key="index">
            <td style="cursor: pointer;"><router-link :to="journalTo(typeobj)" @click.native="nowType = typeobj">{{showName(typeobj)}}</router-link></td>
          </tr>
        </table>
      </div>
    </div>
    <router-view v-else :type="nowType"></router-view>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message, ShowPage } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'journal',
  data() {
    return {
      types: [],
      nowType: '',
      showPage: ShowPage(sessionStorage.getItem('locale')),
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.initType();
    },
    initType() {
			this.getTypeData();
		},
    initNowType() {
      if(this.$route.params.journalid) {
        this.types.some(type => {
          if (String(type.id) === String(this.$route.params.journalid)) {
            this.nowType = type;
            return true;
          }
        });
      }
    },
    getTypeData() {
			axios.get(API.code + `?type=1`)
      .then(response => {
        this.types = response.data.filter(data => {
            return data.trash !== 1;
          });
        this.initNowType();
      })
      .catch(error => {
        GetErrorHandler.bind(this)(error);
      });
		},
    
    journalTo(typeobj) {
      const to = { name: 'journal_info', params: { journalid: typeobj.id } }
      if (sessionStorage.getItem('locale') === 'EN') to.query = { L: 'EN' }
      return to
    },
    
    showName(typeobj) {
      let show = {'CH': typeobj.nameCh, 'EN': typeobj.nameEn}
      return show[sessionStorage.locale];
    },
  },
}

</script>
<style lang="scss">
#journal {
  table,
  th,
  td {
    border: 1px solid #ccc;
    border-collapse: collapse;
    padding: 10px;
  }
  tr {
    &:first-child {
      background-color: #eee;
    }
  }
  a {
    color: inherit;
    text-decoration: none;
  }
}

</style>



// WEBPACK FOOTER //
// Journal.vue?2f5b867e